import { defineStore } from 'pinia';

export const useUserStore = defineStore('user-store', {
  state: () => ({
    userMetaData: {},
    isUserLoggedIn: false,
  }),
  actions: {
    addUserMetaData(data) {
      this.userMetaData = data;
    },
    removeUserData() {
      this.userMetaData = {};
    },
    updateUserStatus(val) {
      this.isUserLoggedIn = val;
    },
  },
  getters: {
    getUserGroup() {
      return this.userMetaData?.data?.membership?.[0]?.affiliationMembership || '';
    },
    getUserIsLoggedIn () {
      return this.isUserLoggedIn;
    }
  },
});